export const transitionDuration = 300;
